import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList, Folder, ChevronRight } from 'lucide-react';


// Convert to React component
const HodContractualNav = ({ isHovered, styles, onToggle }) => {
     const [adminOpen, setAdminOpen] = useState(false);



     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Home size={20} />
                    {isHovered && <span>Dashboard</span>}
               </NavLink>

               <NavLink to="/hr-radiology-assessment" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>HR Radiology Assessment</span>}
               </NavLink>

               <div style={{ position: 'relative' }}>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              marginLeft: '0px',
                              marginTop: '0px',
                              color: '#333',
                              opacity: 1,
                         }}
                         onClick={() => setAdminOpen(!adminOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span>Admin</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: adminOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                             color: "inherit"
                                        }}
                                   />
                              </>
                         )}
                    </button>

                    {adminOpen && (
                         <div
                              className="submenu"
                              style={{
                                   ...styles.submenu,
                                   position: 'absolute',
                                   left: 0,
                                   top: '100%',
                                   background: '#fff',
                                   boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                   borderRadius: '8px',
                                   padding: '8px 0',
                                   minWidth: '180px',
                                   zIndex: 100,
                                   display: 'flex',
                                   flexDirection: 'column',
                                   alignItems: 'flex-start',
                                   gap: '4px',
                              }}
                              onMouseLeave={() => setAdminOpen(false)}
                         >
                              <NavLink
                                   to="/dutyroster"
                                   className="submenu-item"
                                   style={({ isActive }) => ({
                                        ...styles.submenuItem,
                                        ...(isActive ? styles.submenuItemActive : {}),
                                   })}
                              >
                                   <Folder size={18} style={{ marginRight: 8 }} />
                                   <span>Duty Roster</span>
                              </NavLink>

                              <NavLink
                                   to="/dutyrosterbulk"
                                   className="submenu-item"
                                   style={({ isActive }) => ({
                                        ...styles.submenuItem,
                                        ...(isActive ? styles.submenuItemActive : {}),
                                   })}
                              >
                                   <Folder size={18} style={{ marginRight: 8 }} />
                                   <span>Duty Roster Bulk</span>
                              </NavLink>

                              <NavLink
                                   to="/employee-attendance"
                                   className="submenu-item"
                                   style={({ isActive }) => ({
                                        ...styles.submenuItem,
                                        ...(isActive ? styles.submenuItemActive : {}),
                                   })}
                              >
                                   <ClipboardList size={18} style={{ marginRight: 8 }} />
                                   <span>Employee Attendance</span>
                              </NavLink>
                         </div>
                    )}
               </div>
          </>
     );
};

// Export function that returns the component (for backward compatibility)
export const hrNav = (isHovered, styles, onToggle) => {
     return <HodContractualNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default HodContractualNav;